export class TreeNodeTypes {
	static device: string = "Device";
	static deviceType: string = "DeviceType";
	static deviceTypes: string = "DeviceTypes";
	static location: string = "Location";
	static structure: string = "Structure";
	static zone: string = "Zone";
}